import { render, staticRenderFns } from "./RecieverInfo.vue?vue&type=template&id=2c7f8db8&scoped=true"
import script from "./RecieverInfo.vue?vue&type=script&lang=js"
export * from "./RecieverInfo.vue?vue&type=script&lang=js"
import style0 from "./RecieverInfo.vue?vue&type=style&index=0&id=2c7f8db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f8db8",
  null
  
)

export default component.exports